export default "__VITE_PUBLIC_ASSET__f4d41b69__"